import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { useShopRoutes } from "../../../hooks/useShopRoutes";
import { useTranslation } from "react-i18next";

const SettingsSideBar = (props) => {
  const route = useShopRoutes();
  const location = useLocation();
  const { t } = useTranslation();

  // const [isGeneralSettingsOpen, setIsGeneralSettingsOpen] = useState(false);
  // const [isWebsiteSettingsOpen, setIsWebsiteSettingsOpen] = useState(false);


  // const toggleGeneralSettings = () => {
  //   setIsGeneralSettingsOpen(!isGeneralSettingsOpen);
  // };

  // const toggleWebsiteSettings = () => {
  //   setIsWebsiteSettingsOpen(!isWebsiteSettingsOpen);
  // };


  return (
    <div>
      <div className="settings-sidebar" id="sidebar2" >

        <div className="sidebar-inner slimscroll">
          <Scrollbars
            style={{ marginRight: -5, height: 800 }}
            autoHide
            autoHeight
            autoHeightMin={400} // Set a minimum height for the scrollbar
            {...props}

          >
            <div id="sidebar-menu5" className="sidebar-menu">
              <h4 className="fw-bold fs-18 mb-2 pb-2">  {t("settingsSidebar.companySettings")}</h4>
              <ul>
                <li className="submenu-open">
                  <ul>

                    <li>
                      <Link
                        to={route.generalsettings}
                        className={
                          location.pathname === route.generalsettings
                            ? "active"
                            : ""
                        }
                      >
                       { t("settingsSidebar.companyProfile")}
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to={route.storelist}
                        className={
                          location.pathname === route.storelist
                            ? "active"
                            : ""
                        }
                      >
                        Entité
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to={route.accountlist}
                        className={
                          location.pathname === route.accountlist
                            ? "active"
                            : ""
                        }
                      >
                       {t("settingsSidebar.bankAccounts")}
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={route.taxrates}
                        className={
                          location.pathname === route.taxrates
                            ? "active"
                            : ""
                        }
                      >
                    { t("settingsSidebar.taxes")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={route.companysettings}
                        className={
                          location.pathname === route.companysettings
                            ? "active"
                            : ""
                        }
                      >
                      { t("settingsSidebar.vatSituations")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={route.companiestypes}
                        className={
                          location.pathname === route.companiestypes
                            ? "active"
                            : ""
                        }
                      >
                      { t("settingsSidebar.companyTypes")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={route.paymentmethod}
                        className={
                          location.pathname === route.paymentmethod
                            ? "active"
                            : ""
                        }
                      >
                       { t("settingsSidebar.paymentMethods")}
                      </Link>
                    </li>


                  </ul>
                </li>
              </ul>
            </div>
          </Scrollbars>
        </div>

      </div>
    </div>
  );
};
export default SettingsSideBar;
